import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'full-screen-image-viewer',
  templateUrl: './full-screen-image-viewer.component.html',
  styleUrls: ['./full-screen-image-viewer.component.css'],
})
export class FullScreenImageViewerComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { imageUrl: string | SafeUrl; title: string },
    public matDialogRef: MatDialogRef<FullScreenImageViewerComponent>,
    private sanitizer: DomSanitizer
  ) {}

  get imageUrl(): string | SafeUrl {
    return this.data.imageUrl;
  }

  get title(): string {
    return this.data.title || 'Image Viewer';
  }

  close(): void {
    this.matDialogRef.close();
  }
}
